import { render, staticRenderFns } from "./ListStudentTable.vue?vue&type=template&id=71e46e60&scoped=true"
import script from "./ListStudentTable.vue?vue&type=script&lang=js"
export * from "./ListStudentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e46e60",
  null
  
)

export default component.exports